import React from 'react'
import PropTypes from 'prop-types'

const ExternalVideo = props => {
  const video = props.video
  const renderVideo = () => {
    if (video.facebook) {
      return (
        <div
          id={`fb_${props.id}`}
          className='fb-video'
          data-href={video.external_video_url}
          data-video-id={video.id}
          data-allowfullscreen
          data-preview='true'
        />
      )
    } else if (video.youtube) {
      return (
        <iframe
          id={`yt_${props.id}`}
          className='yt-video'
          data-video-id={video.id}
          frameBorder='0'
          allowFullScreen
        />
      )
    } else {
      return (
        <iframe
          src={video.external_video_url}
          frameBorder='0'
          allowFullScreen
        />
      )
    }
  }

  return <div className='video-player-external'>{renderVideo()}</div>
}

ExternalVideo.defaultProps = {
  id: 'videoPlayer'
}

ExternalVideo.propTypes = {
  id: PropTypes.string,
  video: PropTypes.object
}

export default ExternalVideo
